import { render, staticRenderFns } from "./CompanyConfigurations.vue?vue&type=template&id=474a230f&"
import script from "./CompanyConfigurations.vue?vue&type=script&lang=js&"
export * from "./CompanyConfigurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports